import { Col, Row } from "react-bootstrap";
import React from "react";

export  const TwoFAMethod = {
  Sms: 'sms',
  AuthApp: 'authApp',
  None: 'none'
}
const SelectTwoStepVerification = ({ currentMethod = TwoFAMethod.None,  onChange }) => {

  const Heading = () => {
    if (currentMethod === TwoFAMethod.AuthApp) {
      return (
            <p>
              Change your two-step verification method to SMS
            </p>
      )
    }
    if (currentMethod === TwoFAMethod.Sms) {
      return (
            <p>
              Change your two-step verification method to Auth App
            </p>
      )
    }

      return (
        <>
          <p>
            For your security, Big Yellow uses two factor authentication each time
            you log in to Check-in Online.
          </p>
          <p>
            Please choose how you would like to receive your two-step verification
          </p>
          </>

      )
  }

  // shows two buttons one for SMS and one for Auth app
  return (

    <div className={`form-content`}>
      <React.Fragment>
        <Row className={"mb-4"}>
          <Col>
            <Heading />
          </Col>
        </Row>
        <Row>
          <Col>
      <button
        onClick={() => onChange("sms")}
        className='btn btn-primary btn-block'
        disabled={currentMethod === TwoFAMethod.Sms}
      >
        SMS
      </button>
          </Col>
          <Col>
      <button
        onClick={() => onChange("authApp")}
        className='btn btn-primary btn-block'
        disabled={currentMethod === TwoFAMethod.AuthApp}
      >
        Auth App
      </button>
            </Col>
          </Row>
      </React.Fragment>
    </div>

  )
}

export default SelectTwoStepVerification;